// සුවඩි Smart Warranty Assistant - Page Component
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SmartWarrantyAssistant } from '../components/warranty/SmartWarrantyAssistant';
import type { ExtractedData } from '../components/warranty/SmartWarrantyAssistant/types';
import type { WarrantyRequest } from '../types/warranty';
import { warrantyService } from '../services/warranty';
import { authService } from '../services/auth';

const SmartWarrantyAssistantPage: React.FC = () => {
  const navigate = useNavigate();

  const handleWarrantySaved = async (data: ExtractedData) => {
    try {
      const currentUser = await authService.getCurrentUser();
      if (!currentUser) {
        console.error('No user logged in');
        navigate('/auth/login');
        return;
      }

      // Calculate warranty expiry date
      const purchaseDate = new Date(data.purchaseDate || new Date());
      const warrantyPeriodMatch = data.warrantyPeriod?.match(/(\d+)\s*(year|month|day)s?/i);
      let warrantyExpiryDate = new Date(purchaseDate);
      
      if (warrantyPeriodMatch) {
        const [, amount, unit] = warrantyPeriodMatch;
        const duration = parseInt(amount);
        
        switch (unit.toLowerCase()) {
          case 'year':
            warrantyExpiryDate.setFullYear(warrantyExpiryDate.getFullYear() + duration);
            break;
          case 'month':
            warrantyExpiryDate.setMonth(warrantyExpiryDate.getMonth() + duration);
            break;
          case 'day':
            warrantyExpiryDate.setDate(warrantyExpiryDate.getDate() + duration);
            break;
        }
      } else {
        // Default to 1 year if warranty period is unclear
        warrantyExpiryDate.setFullYear(warrantyExpiryDate.getFullYear() + 1);
      }

      // Convert extracted data to warranty request format
      const warrantyRequest: WarrantyRequest = {
        userId: currentUser.userId || '',
        productName: data.productName || '',
        brand: data.brand || '',
        modelNumber: '', // Not extracted from AI, user can edit later
        purchaseDate: data.purchaseDate || new Date().toISOString().split('T')[0],
        purchaseStore: data.purchaseStore || '',
        warrantyExpiryDate: warrantyExpiryDate.toISOString().split('T')[0],
        entryMethod: 'document-extraction',
        category: 'Electronics' // Default category
      };

      // Save to warranty service
      const result = await warrantyService.createWarranty(warrantyRequest);
      
      if (result) {
        // Navigate to warranties list
        navigate('/warranties');
      }
    } catch (error) {
      console.error('Error saving warranty:', error);
    }
  };

  return (
    <SmartWarrantyAssistant 
      onWarrantySaved={handleWarrantySaved}
      className="warranty-assistant-page"
    />
  );
};

export default SmartWarrantyAssistantPage;
